<template>
  <v-col class="elevation-5 rounded-xl my-10 px-5 py-4">
    <p>{{ question.title }}</p>
    <p class="mb-1 black--text">
      <strong>{{ question.description }}</strong>
    </p>

    <ExtraContent v-bind:contents="question.extracontent" />

    <v-radio-group v-model="result" :rules="rules[locale]">
      <v-radio
        v-for="(option, index) in question.options"
        :key="index"
        :label="option.label"
        :value="option.value"
      ></v-radio>
    </v-radio-group>
  </v-col>
</template>

<script>
import ExtraContent from "./ExtraContent";
import { requiredRule } from "@/common/formRules.js";
export default {
  name: "Question",
  props: {
    value: String,
    question: Object,
    locale: String
  },
  components: {
    ExtraContent
  },
  data() {
    return {
      rules: requiredRule
    };
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped>
label {
  color: #000 !important;
}
</style>
